var nbno = {
	"coupon-callout": {
	"coupon-code": "Kode",
	"coupon-message-with-price": "Da er det bare {{ price }}",
	"coupon-expiry-message": "Utløper {{ Date }}.",
	"code-at-checkout": "Oppgi koden i kassen. Kan ikke kombineres med andre kampanjekoder, tilbud eller rabatter.",
	"cancel-icon": "Avbryt",
	"info-icon": "Se detaljer",
	"check-icon": "Påført",
	"promo-code": "Kampanjekode",
	"coupon-callout-popover": "Popover-kupong"
}
};

export { nbno as default };
//# sourceMappingURL=src-localization-texts-nb-no.json.js.map
